<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>Monumento al General Ignacio Zaragoza</h2>
    <img @click="imageClicked(0)" src="galerias/sala3/S3_G7.jpg" class="mainphoto"/>
    <p class="photo-description">Título: <b>Monumento a Ignacio Zaragoza</b><br>
      Autor: Jorge González<br>
      Año: 2016<br>
      Técnica: Fotografía digital<br>
    </p>
    <p>Este monumento se ubica dentro del centro cívico cultural 5 de mayo. Se trata de una fuente con forma ovalada dentro de la cual destacan 6 columnas, sobre una de ella se eleva una escultura que retrata al General Ignacio Zaragoza montando a caballo. Sobre las otras 5 columnas se colocaron cañones que fueron usados durante la batalla. Dentro de este monumento, existe una cripta donde descansan los restos del general Ignacio Zaragoza. Su construcción data de 1976, siendo obra del Arquitecto Víctor Manuel Terán Bonilla.</p>
    <p>Actualmente es uno de los principales escenarios de las celebraciones que cada año conmemoran el triunfo sobre los franceses en 1862.</p>
    <h5>Ver más:</h5>
    <p>Conoce la biografía del General Zaragoza  en este link:<br>
      <a target="_blank" href="http://bdmx.mx/documento/biografia-ignacio-zaragoza">bdmx.mx</a>
    </p>

    <h3>Monumento al General Ignacio Zaragoza</h3>
    <img @click="imageClicked(1)" src="galerias/sala3/S3_SubG7.png" class="mainphoto"/>
    <p class="photo-description">Título: <b>Monumento a Ignacio Zaragoza</b><br>
      Autor: Agustín Víctor Casasola<br>
      Año: 1962<br>
      Técnica Fotografía<br>
      Colección Fototeca Nacional<br>
    </p>
    <p>Esta fotografía forma parte de la colección que  Agustín Víctor Casasola capturó como parte de los festejos del centenario de la Batalla del 5 de mayo en 1962.</p>
    <p>En ella se muestra el antiguo monumento en memoria del General Ignacio Zaragoza, originalmente ubicado cerca de las capillas del Calvario, y posteriormente trasladado a un costado del fuerte de Loreto.</p>
    <p>De este monumento solamente sobrevive la escultura del General Zaragoza, realizada en bronce a finales del siglo XIX por el escultor Jesús Fructuoso Contreras, ya que fue integrada al  monumento construido en 1976.</p>
    <h5>Ver más:</h5>
    <p>Imagen propiedad del Instituto Nacional de Antropología e Historia, alojada en:<br>
      <a target="_blank" href="http://www.mediateca.inah.gob.mx/repositorio/islandora/object/fotografia%3A101672">www.mediateca.inah.gob.mx</a>
    </p>
  </div>
</template>

<script>
export default {
  name: "s32g07",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    },
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
